import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import DeviceTruckImplement from './device-truck-implement';
import DeviceTruckImplementDetail from './device-truck-implement-detail';
import DeviceTruckImplementUpdate from './device-truck-implement-update';
import DeviceTruckImplementDeleteDialog from './device-truck-implement-delete-dialog';
import PrivateRoute from 'app/shared/auth/private-route';
import { AUTHORITIES } from 'app/config/constants';
import DeviceTruckImplementUpdateMcdFirmware from './device-truck-implemente-update-mdc-firmware';

const Routes = ({ match }) => (
  <>
    <Switch>
      <PrivateRoute exact path={`${match.url}/new`} component={DeviceTruckImplementUpdate} hasAnyAuthorities={[AUTHORITIES.ADMIN]} />
      <PrivateRoute path={match.url} component={DeviceTruckImplement} hasAnyAuthorities={[AUTHORITIES.ADMIN]} />
      <PrivateRoute exact path={`${match.url}/:id/edit`} component={DeviceTruckImplementUpdate} hasAnyAuthorities={[AUTHORITIES.ADMIN]} />
      <PrivateRoute exact path={`${match.url}/:id`} component={DeviceTruckImplementDetail} hasAnyAuthorities={[AUTHORITIES.ADMIN]} />
    </Switch>
    <PrivateRoute exact path={`${match.url}/:id/delete`} component={DeviceTruckImplementDeleteDialog} hasAnyAuthorities={[AUTHORITIES.ADMIN]} />
    <PrivateRoute exact path={`${match.url}/mcd-firmware`} component={DeviceTruckImplementUpdateMcdFirmware} hasAnyAuthorities={[AUTHORITIES.ADMIN]} />
  </>
);

export default Routes;
